import React from 'react';
import { Snackbar, SnackbarContent } from '@mui/material';
import htmlToImage, { toPng } from 'html-to-image';
import html2canvas from 'html2canvas';

export const STORAGE_URL = 'https://storage.googleapis.com/3d-container/';
export function capitalizeFirstWord(str) {
  return str?.charAt(0).toUpperCase() + str?.slice(1);
}

export function showToast(type, message, setToast) {
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={type}
      autoHideDuration={5000}
      onClose={() => setToast(false)}
    >
      <SnackbarContent
        style={{
          backgroundColor: type === 'success' ? 'green' : 'red',
        }}
        message={message}
      />
    </Snackbar>
  );
}
export const downloadFileFromUrl = (url, fileName) => {
  const anchorElement = document.createElement('a');
  anchorElement.href = url;
  const extension = url.split('.').pop();
  const fileNameExt = fileName + '.' + extension;
  anchorElement.download = fileNameExt;
  anchorElement.click();
};
export const openFileInNewTab = (url) => {
  // This will open the file in a new tab
  window.open(url, '_blank');
};

export const htmlToImageConverter = async (elementRef, fileName) => {
  const divElement = elementRef.current;

  if (!divElement) {
    return;
  }

  try {
    const dataUrl = await toPng(elementRef.current, { cacheBust: false });
    const link = document.createElement('a');
    link.download = fileName || 'nft.png';
    link.href = dataUrl;
    link.click();
  } catch (error) {
    console.error('Error converting div to image:', error);
  }
};

export async function startRecording(
  id,
  fileName,
  setRecording,
  type,
  setPreviewContent,
  duration = 10,
  audioRef,
  isPlaying,
  setConverting,
  downloadType,
  nftId
) {
  setRecording(true);
  try {
    const chunks = [];
    let canvasElt = document.getElementById(id);
    let canvasElt1 = canvasElt?.firstChild;

    // Ensure proper color space and pixel format

    const videoStream = canvasElt1.captureStream(60);
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    let combinedStream;
    if (isIOS) {
      const mimeType = 'video/webm;codecs=vp8,opus';
      const fallbackMimeType = 'video/mp4;codecs=avc1.42E01E,mp4a.40.2';
      const selectedMimeType = MediaRecorder.isTypeSupported(mimeType)
        ? mimeType
        : MediaRecorder.isTypeSupported(fallbackMimeType)
          ? fallbackMimeType
          : 'video/webm';
      if (isPlaying && audioRef.current) {
        try {
          const audioContext = new (window.AudioContext ||
            window.webkitAudioContext)();
          const source = audioContext.createMediaElementSource(
            audioRef.current
          );
          const destination = audioContext.createMediaStreamDestination();
          source.connect(destination);
          source.connect(audioContext.destination);

          combinedStream = new MediaStream([
            ...videoStream.getVideoTracks(),
            ...destination.stream.getAudioTracks(),
          ]);
        } catch (e) {
          console.warn('Failed to capture audio stream:', e);
          combinedStream = new MediaStream([...videoStream.getVideoTracks()]);
        }
      } else {
        combinedStream = new MediaStream([...videoStream.getVideoTracks()]);
      }

      const recorderOptions = {
        mimeType: selectedMimeType,
        videoBitsPerSecond: 2500000, // 2.5 Mbps
        audioBitsPerSecond: 128000, // 128 kbps
      };

      const rec = new MediaRecorder(combinedStream, recorderOptions);

      rec.onerror = (e) => {
        console.error('MediaRecorder error:', e);
        setRecording(false);
      };

      rec.ondataavailable = (e) => chunks.push(e.data);
      rec.onstop = async (e) => {
        const blob = new Blob(chunks, { type: 'video/mp4' });
        const url = URL.createObjectURL(blob);
        const extension = selectedMimeType.includes('mp4') ? 'mp4' : 'webm';

        if (type === 'onlyRecord') {
          setRecording(false);
          setPreviewContent(blob);
        } else {
          setRecording(false);

          // Create a container for preview and download
          const container = document.createElement('div');
          container.style.cssText = `
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: #000;
          padding: 20px;
          border-radius: 10px;
          box-shadow: 0 0 10px rgba(0,0,0,0.3);
          z-index: 9999;
          max-width: 90vw;
          max-height: 90vh;
          overflow: auto;
          `;

          // Add video preview
          const video = document.createElement('video');
          video.src = url;
          video.controls = true;
          video.style.maxWidth = '100%';
          video.style.marginBottom = '15px';
          container.appendChild(video);

          // Add download button
          const downloadBtn = document.createElement('button');
          downloadBtn.textContent = 'Download Video';
          downloadBtn.style.cssText = `
            display: block;
            width: 100%;
            padding: 10px;
            border:"1px solid #fff";
            blackground: #000 !important;
            color: #000;
            border-radius: 5px;
            cursor: pointer;
            margin-bottom: 10px;
            `;

          // Add close button
          const closeBtn = document.createElement('button');
          closeBtn.textContent = 'Close';
          closeBtn.style.cssText = `
            display: block;
            width: 100%;
            padding: 10px;
            border:"1px solid #fff";
            blackground: #000;
            color: #000;
            border-radius: 5px;
            cursor: pointer;
            `;

          // Handle download
          downloadBtn.onclick = () => {
            // For iOS, create a temporary link and trigger download
            const tempLink = document.createElement('a');
            tempLink.href = url;
            tempLink.download =
              'MutantHounds_' + '_' + nftId + '_' + fileName + `.${extension}`;
            tempLink.style.display = 'none';
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
          };

          // Handle close
          closeBtn.onclick = () => {
            document.body.removeChild(container);
            URL.revokeObjectURL(url);
          };

          container.appendChild(downloadBtn);
          container.appendChild(closeBtn);
          document.body.appendChild(container);
        }
      };
      rec.start(1000);

      setTimeout(
        () => {
          rec.stop();
        },
        parseInt(duration) * 1000
      );
    } else {
      if (isPlaying) {
        const audioStream = audioRef.current.captureStream();
        combinedStream = new MediaStream([
          ...videoStream.getVideoTracks(),
          ...audioStream.getAudioTracks(),
        ]);
      } else {
        combinedStream = new MediaStream([...videoStream.getVideoTracks()]);
      }
      const recorderOptions = {
        mimeType: GetTouchDevices()
          ? 'video/webm;codecs=vp9,opus'
          : 'video/webm;codecs=vp9',
        videoBitsPerSecond: 8000000,
        audioBitsPerSecond: 128000,
      };
      videoStream.getVideoTracks().forEach((track) => {
        const capabilities = track.getCapabilities();
        if (capabilities.colorSpace) {
          track.applyConstraints({
            colorSpace: 'srgb',
          });
        }
      });
      const rec = new MediaRecorder(combinedStream, recorderOptions);
      rec.ondataavailable = (e) => chunks.push(e.data);
      rec.onstop = async (e) => {
        const blob = new Blob(chunks, { type: 'video/mp4' });
        if (type === 'onlyRecord') {
          setRecording(false);
          setPreviewContent(blob);
        } else {
          setRecording(false);
          setConverting(true);
          // Do the convertion from api, and then download
          const formData = new FormData();
          formData.append('video', blob, 'recording.webm'); // Append the Blob with a filename
          fetch(
            'https://twitter-backend-dot-inceptivestudio-370108.uc.r.appspot.com/convert',
            {
              // fetch("http://localhost:3010/convert", {
              method: 'POST',
              body: formData,
            }
          )
            .then((response) => {
              if (!response.ok) {
                throw new Error(`Failed to upload video: ${response.status}`);
              }
              return response.blob();
            })
            .then((convertedBlob) => {
              const url = URL.createObjectURL(convertedBlob);
              const a = document.createElement('a');
              a.href = url;
              a.download =
                'MutantHounds_' + '_' + nftId + '_' + fileName + '.mp4';
              a.click();
              URL.revokeObjectURL(url);
              setConverting(false);
            })
            .catch((error) => {
              console.error('Error during file upload or conversion:', error);
              setConverting(false);
            });
        }
      };
      rec.start();
      setTimeout(
        () => {
          rec.stop();
        },
        parseInt(duration) * 1000
      );
    }
  } catch (err) {
    console.log(err, 'errerrerrerrerrerrerr');
  }
}

export function exportVid(blob, fileName, setRecording) {
  let vid = document.createElement('video');
  vid.src = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.download = fileName + '.mp4';
  a.href = vid.src;
  // a.textContent = fileName;
  a.click();
  setRecording(false);
}

export const validatePhoneNumber = (e) => {
  if (!e?.includes('/')) {
    return true;
  }
  if (e && e.length > 0) {
    const diff = e.split('/');
    const targetValueLength = diff[0].length;
    const requiredLength = (diff[1]?.match(/\./g) || []).length;
    if (requiredLength !== targetValueLength) {
      return false;
    } else if (targetValueLength === requiredLength) {
      return true;
    }
  }
  return false;
};

export const htmlToImageConvert = async (
  name,
  elementRef,
  setFullScreen = null,
  element = '#videoAnimation'
) => {
  try {
    const data = await html2canvas(document.querySelector(element), {
      allowTaint: true,
      useCORS: true,
      scale: 4,
    });
    var anchorTag = document.createElement('a');
    anchorTag.download =
      'MutantHounds_' + (name ? name : 'NFT-preview') + '.jpg';
    anchorTag.href = data.toDataURL();
    anchorTag.target = '_blank';
    anchorTag.click();
    if (setFullScreen) {
      exitFullscreen(elementRef, setFullScreen);
    }
  } catch (err) {
    console.log(err);
  }
};
export const exitFullscreen = (elementRef, setFullScreen) => {
  if (elementRef.current) {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      // IE/Edge
      document.msExitFullscreen();
    }
    setFullScreen(false);
  }
};
export function GetTouchDevices() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

export function wideScreen() {
  if (
    window.innerWidth > 3500 ||
    document.documentElement.clientWidth > 3500 ||
    document.body.clientWidth > 3500 ||
    window.screen.width > 3500
  ) {
    return true;
  } else {
    return false;
  }
}
